import React from 'react'
import { Form, FormInstance, Radio } from 'antd'
import { DirectionKey } from '../types'

type DirectionFieldProps = {
  form: FormInstance
  value: DirectionKey
  /** Notifies the host form so it can rebuild its steps for the chosen direction. */
  onChange: (directionKey: DirectionKey) => void
}

/** MATCH-only: which way the value flows (external → adopets, or the reverse). */
export const DirectionField = ({ form, value, onChange }: DirectionFieldProps) => {
  const handleChange = (directionKey: DirectionKey) => {
    form.setFieldsValue({ direction_key: directionKey })
    onChange(directionKey)
  }

  return (
    <Form.Item label="Direction" help="Which way the value flows.">
      <Radio.Group
        optionType="button"
        buttonStyle="solid"
        value={value}
        onChange={e => handleChange(e.target.value)}
      >
        <Radio.Button value="INPUT">Input (external → adopets)</Radio.Button>
        <Radio.Button value="OUTPUT">Output (adopets → external)</Radio.Button>
      </Radio.Group>
    </Form.Item>
  )
}
